import { useMemo } from "react";
import { useGameState } from "../../../game/contact3d/replicatedObjects/GameState";
import { usePlayerId } from "../../../core/game/client/GameContextHooks";
import { toCssColorString } from "../../core/util/ColorPreset";
export function useSecretWordTextProps() {
    const { secretWordGiverId, secretWord, currentSecretWordLetters, numRevealedLetters, } = useGameState();
    const playerId = usePlayerId();
    return useMemo(() => {
        if (secretWord === undefined) {
            return {
                text: '<Awaiting secret word>',
                color1: '#000000',
            };
        }
        else if (playerId === secretWordGiverId) {
            return {
                text: secretWord.toUpperCase(),
                color1: toCssColorString(0x924949),
                color2: '#000000',
                color1Length: numRevealedLetters,
            };
        }
        else {
            return {
                text: currentSecretWordLetters.toUpperCase(),
                color1: '#000000',
            };
        }
    }, [secretWord, playerId, secretWordGiverId, numRevealedLetters, currentSecretWordLetters]);
}
//# sourceMappingURL=UseSecretWordTextProps.js.map